import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Sun, Sparkles, Leaf, ShieldCheck, User } from "lucide-react";

const items = [
  { to: "/today",     key: "nav.today",     icon: Sun,        testid: "nav-today" },
  { to: "/decode",    key: "nav.decode",    icon: Sparkles,   testid: "nav-decode" },
  { to: "/sanctuary", key: "nav.sanctuary", icon: Leaf,       testid: "nav-sanctuary" },
  { to: "/safety",    key: "nav.safety",    icon: ShieldCheck,testid: "nav-safety" },
  { to: "/me",        key: "nav.me",        icon: User,       testid: "nav-me" },
];

export default function BottomNav() {
  const { t } = useTranslation();
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-40 px-3 pb-3"
    >
      <div className="glass border border-border rounded-full shadow-lg flex items-center justify-around px-2 py-2">
        {items.map(({ to, key, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testid}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-full transition-all duration-300 ${
                isActive
                  ? "bg-brand text-white shadow-md"
                  : "text-foreground/70 hover:text-brand"
              }`
            }
          >
            <Icon className="w-5 h-5" />
            <span className="text-[10px] tracking-wide font-medium">{t(key)}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
